module.exports = __webpack_public_path__ + "img/student-second-prize.714f149.png";